<template>
  <div class="5c">
    <h3 class="uk-margin-medium-top">5C.  CAPITAL O PATRIMONIO                    </h3>
    <p>Contesta las siguientes preguntas:</p>
    <form id="form" class="uk-text-left">

      <div class="uk-margin">
        <label >a) Tipo de Vivienda</label>
        <select class="uk-select" required v-model="data['a - Tipo de Vivienda']" >
          <option value="7">Propia</option>
          <option value="5">Vive con familiares</option>
          <option value="3">Arrendada</option>
        </select>
      </div>

      <div class="uk-margin" v-if="data['a - Tipo de Vivienda'] == 7">
        <label >a - 1) Cual es el valor comercial de su vivienda</label>
        <select class="uk-select" required v-model="data['a - Valor de la vivienda']" >
          <option value="7">Mas o igual a 5.5 millones</option>
          <option value="6">Entre 5 y 5.5 millones</option>
          <option value="5">Entre 4 y 4.5 millones</option>
          <option value="4">Entre 3 y 3.5 millones</option>
          <option value="3">Entre 2 y 2.5 millones</option>
          <option value="2">Entre 1 y 1.5 millones</option>
          <option value="1">Menos de 1 millón</option>
        </select>   
      </div>
      



      <div class="uk-margin">
        <label >b) Valores estimados de otros bienes <br> <br></label>
        <div uk-grid class="uk-child-width-1-2 uk-grid-small">
          <div>
            Casa/dptos(s)
          </div>
          <div>
            <input v-model="otros_bienes['Casas o deptos']" type="number" step="0.01" placeholder="$ Casas" class="uk-input">
          </div>
          <div>
            Terrenos
          </div>
          <div>
            <input v-model="otros_bienes['Terrenos']" type="number" step="0.01" placeholder="$ Terrenos" class="uk-input">
          </div>
          <div>
            Vehículos
          </div>
          <div>
            <input v-model="otros_bienes['Vehículos']" type="number" step="0.01" placeholder="$ Vehículos" class="uk-input">
          </div>
          <div>
            Muebles y enseres
          </div>
          <div>
            <input v-model="otros_bienes['Muebles']" type="number" step="0.01" placeholder="$ Muebles" class="uk-input">
          </div>
        </div> 
      </div>
      

      <div class="uk-margin uk-text-center">
         <button  class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : this.$score['5C  CAPITAL O PATRIMONIO'] ? this.$score['5C  CAPITAL O PATRIMONIO'] : {},
      otros_bienes : this.$score['5C  CAPITAL O PATRIMONIO'] ? this.$score['5C  CAPITAL O PATRIMONIO']['Valores de sus otros bienes'] ? this.$score['5C  CAPITAL O PATRIMONIO']['Valores de sus otros bienes']: {} : {},
    }
  },
  computed:{
    calif : function(){
      var value = 0.0
      for (var i in this.data){
        if(i == 'PUNTAJE TOTAL' || i == 'c - Valor de las bienes' || i == 'a - Valor de la vivienda' || i == 'Valores de sus otros bienes' ){
          continue
        }
        if(!isNaN(parseFloat(this.data[i]))){
          value += parseFloat(this.data[i])
        }
      }
      value = value * 70.0 / 10.0
      value = value.toFixed(1)
      if(this.otros_bienes != {}) this.data['Valores de sus otros bienes'] = this.otros_bienes
      this.data['PUNTAJE TOTAL'] = value
      return value
    }
  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.calif + 1
      this.$score['5C  CAPITAL O PATRIMONIO'] = this.data
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      this.$router.push('precal')
    }.bind(this))
    window.scroll(0,0)
    this.$score = JSON.parse(sessionStorage.getItem('score'))
    if(this.$score['5C  CAPITAL O PATRIMONIO']) this.data = this.$score['5C  CAPITAL O PATRIMONIO']
    if(this.data['Valores de sus otros bienes']) this.otros_bienes = this.data['Valores de sus otros bienes']
  }
    
}
</script>
